import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import type {ReactNode} from "react";
import {useTranslation} from "react-i18next";

interface RightSidebarPanelHeaderProps {
    title: ReactNode
    titleAdornment?: ReactNode
    onClose?: () => void
}

export function RightSidebarPanelHeader({
    title,
    titleAdornment,
    onClose,
}: RightSidebarPanelHeaderProps) {
    const {t} = useTranslation();

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 2,
                pt: 2,
                pb: 1,
                flexShrink: 0,
            }}
        >
            <Typography variant="body1" fontWeight={500} sx={{minWidth: 0}}>
                {title}
            </Typography>

            {titleAdornment}

            {onClose && (
                <IconButton
                    type="button"
                    size="small"
                    aria-label={t("Close")}
                    onClick={onClose}
                    sx={{ml: "auto"}}
                >
                    <CloseIcon fontSize="small"/>
                </IconButton>
            )}
        </Box>
    );
}
